import { z } from "zod";
import { baseEntitySchema } from "./base";

export const invoiceStatusSchema = z.enum([
  "draft",
  "sent",
  "paid",
  "void",
  "refunded",
]);
export type InvoiceStatus = z.infer<typeof invoiceStatusSchema>;

export const invoiceDataSchema = z.object({
  inventoryId: z.string(),
  poId: z.string().optional(),
  soId: z.string().optional(),
  amountDue: z.number().nonnegative(),
  currency: z.string().default("USD"),
  status: invoiceStatusSchema,
  issuedAt: z.date().optional(),
  dueAt: z.date().optional(),
  quickbooksReferenceId: z.string().optional(),
});

export type InvoiceData = z.infer<typeof invoiceDataSchema>;
export const invoiceSchema = baseEntitySchema.merge(invoiceDataSchema);
export type Invoice = z.infer<typeof invoiceSchema>;
